// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC3WBaowIAfY1R9ZCA4-AiIaMHKdx8ddGI",
  authDomain: "beautrium-online.firebaseapp.com",
  databaseURL: "https://beautrium-online.firebaseio.com",
  projectId: "beautrium-online",
  storageBucket: "beautrium-online.appspot.com",
  messagingSenderId: "301406468206",
  appId: "1:301406468206:web:98f32d73cf96b26b",
  measurementId: "G-3DMWM0NC37",
  // authDomain: "thebeautrium.com",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;